import { cn } from '@/lib/cn';

interface Props {
  size?: 'sm' | 'md';
  className?: string;
}

// Familycare OS brand lockup: the real app icon next to "Familycare OS" —
// "Familycare" in the ink foreground, "OS" in sage. Mixed case, never
// uppercased. Kept identical to the marketing site + App Store so the app
// name Google verifies on the OAuth consent screen matches every page it
// crawls (a mismatch here is a verification rejection).
export function Wordmark({ size = 'md', className }: Props): JSX.Element {
  const dim = size === 'sm' ? 'h-7 w-7' : 'h-9 w-9';
  const name = size === 'sm' ? 'text-base' : 'text-lg';
  return (
    <div className={cn('inline-flex items-center gap-2.5', className)}>
      <img
        src="/marketing/appicon.png"
        alt=""
        aria-hidden
        width={36}
        height={36}
        className={cn('rounded-[26%] shadow-sm', dim)}
      />
      <span
        className={cn('font-bold tracking-tight', name)}
        style={{ color: '#22314C', letterSpacing: '-0.02em' }}
      >
        Familycare <span style={{ color: '#5E8F6E' }}>OS</span>
      </span>
    </div>
  );
}
